import { faBars, faClose } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuTrigger,
  NavigationMenuSub,
} from '@radix-ui/react-navigation-menu'
import { useTranslations } from 'next-intl'
import { cn } from 'utils/cn'
import { MobileCategoryMenu } from './MobileCategoryMenu'

export const MobileMenu = ({ locale }: { locale: string }) => {
  const t = useTranslations('Navigation.MobileMenu')

  return (
    <NavigationMenuItem
      className='text-text-800 text-body-md font-manrope h-full lg:hidden'
      value='mobile-menu'
    >
      <NavigationMenuTrigger
        className={cn(
          'group flex h-[theme(height.header-mobile)] min-w-11 flex-col items-center justify-center gap-1 whitespace-nowrap',
        )}
        data-testid='mobile-menu-trigger'
        onPointerDown={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <FontAwesomeIcon
          className='group-data-[state=open]:hidden'
          icon={faBars}
          size='2x'
        />
        <span className='sr-only group-data-[state=open]:hidden'>
          {t('toggleButton.open')}
        </span>
        <FontAwesomeIcon
          className='group-data-[state=closed]:hidden'
          icon={faClose}
          size='2x'
        />
        <span className='sr-only group-data-[state=closed]:hidden'>
          {t('toggleButton.close')}
        </span>
      </NavigationMenuTrigger>
      <NavigationMenuContent
        className={cn(
          'data-[motion=from-start]:animate-enterFromRight data-[motion=from-end]:animate-enterFromRight data-[motion=to-start]:animate-exitToRight data-[motion=to-end]:animate-exitToRight max-h-screen-without-header absolute left-0 top-0 z-50 flex h-full w-full flex-col overflow-y-scroll transition-all duration-300 data-[state=closed]:-z-10 data-[state=closed]:opacity-0 data-[state=open]:opacity-100 lg:hidden',
        )}
        data-testid='mobile-menu-content'
      >
        <NavigationMenuSub className=''>
          <MobileCategoryMenu locale={locale} />
        </NavigationMenuSub>
      </NavigationMenuContent>
    </NavigationMenuItem>
  )
}
